import { render, staticRenderFns } from "./aiAssistantTab.vue?vue&type=template&id=9c87fee2&lang=pug"
import script from "./aiAssistantTab.vue?vue&type=script&lang=js"
export * from "./aiAssistantTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports